var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Sparklines',{attrs:{"data":_vm.data,"type":"line","width":_vm.width,"height":_vm.height,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }